import { ContractDocumentColumns } from './ContractDocumentColumns';

export const ContractDocumentListColumns = [
  ContractDocumentColumns.kind,
  ContractDocumentColumns.filename,
  ContractDocumentColumns.description
];
